/**
 * Pricing Configuration Constants
 *
 * Centralized configuration for pricing-related settings.
 */

export const PRICING_CONFIG = {
  /** Default number of days to look ahead for pricing operations */
  DEFAULT_LOOK_AHEAD_DAYS: 365,

  /** Maximum number of days that can be processed (1 year) */
  MAX_LOOK_AHEAD_DAYS: 365,

  /** Number of days to process per batch for API calls */
  BATCH_SIZE: 31,

  /** Debounce time in milliseconds for booking-triggered repricing */
  BOOKING_TRIGGER_DEBOUNCE_MS: 5000,

  /** Backoff between retries when booking-triggered repricing finds the apply lock held (409 apply_in_progress) */
  BOOKING_TRIGGER_LOCK_RETRY_DELAYS_MS: [5000, 15000, 30000],

  /** Maximum allowed price change as a decimal (2.0 = 200%, i.e. allow up to 3x original price) */
  DEFAULT_MAX_PRICE_CHANGE: 2.0,

  /** Minimum confidence threshold for price suggestions (0-1) */
  DEFAULT_MIN_CONFIDENCE: 0.7,
} as const;

export type PricingConfig = typeof PRICING_CONFIG;
